<template>
  <div>
    <!--begin::Items-->
    <div class="scroll-y mh-200px mh-lg-325px">
      <!--begin::Category title-->
      <template v-for="(item, index) in items">
        <h3 class="fs-5 text-muted m-0 pb-5" :class="index > 0 ? 'pt-5' : ''">
          {{ getObjectTypeTitle(item.objectType ?? 0) }}
        </h3>

        <!--end::Category title-->
        <!--begin::Item-->
        <a
          href="javascript:;"
          @click="selecteItem(itemData)"
          :to="getUrl(itemData) ?? ''"
          class="d-flex text-gray-900 text-hover-primary align-items-center mb-5"
          v-for="itemData in item.items"
          :key="itemData.id"
        >
          <!--begin::Symbol-->
          <div class="symbol symbol-40px me-4" v-if="itemData.avatar">
            <img :src="$thumb(itemData.avatar!, 200, 200)" alt="" />
          </div>
          <!--end::Symbol-->
          <!--begin::Title-->
          <div class="d-flex flex-column justify-content-start fw-semibold">
            <span class="fs-6 fw-semibold">{{ itemData.name }}</span>
            <!-- <span class="fs-7 fw-semibold text-muted">Marketing Manager</span> -->
          </div>
          <!--end::Title-->
        </a>
        <!--end::Item-->
      </template>
      <!--end::Item-->
    </div>
    <!--end::Items-->
  </div>
</template>

<script lang="ts">
import { getAssetPath } from "@/core/helpers/assets";
import { defineComponent } from "vue";
import { getObjectTypeTitle, ObjectTypeEnum } from "~/constants/enum";
import type {
  SearchItemDto,
  SearchMultiObjectItemDto,
} from "~/core/services/ApiClient";

export default defineComponent({
  name: "kt-results",
  components: {},
  props: {
    items: {
      type: Array<SearchMultiObjectItemDto>,
      required: false,
      default: () => [],
    },
  },
  setup() {
    const { $thumb } = useNuxtApp();

    const getUrl = (item: SearchItemDto) => {
      if (item.objectType === ObjectTypeEnum.SystemFunction) {
        return item.url ?? "";
      } else {
        switch (item.objectType) {
          case ObjectTypeEnum.News:
            return `/news/edit-${item.id}`;
          case ObjectTypeEnum.Thread:
            return `/thread`;
          case ObjectTypeEnum.Topic:
            return `/topic`;
          case ObjectTypeEnum.Tag:
            return `/thread`;
        }
      }
    };

    const selecteItem = (item: SearchItemDto) => {
      const url = getUrl(item);
      if (url) {
        useRouter().push(url);
        document.getElementById("kt_header_search_toggle")?.click();
      }
    };
    return {
      getAssetPath,
      getObjectTypeTitle,
      $thumb,
      getUrl,
      selecteItem
    };
  },
});
</script>
